<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.call')" position="top" v-if="userInfo.userRole == 'user' && isPermissionCall">
                <feather-icon icon="PhoneIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click="callToCustomer"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.confirm')" position="top"
                        v-if="params.data.status == 1 && isPermissionUpdateBooking">
                <feather-icon icon="CheckIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-success cursor-pointer" @click="confirmRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.complete')" position="top"
                        v-if="params.data.status == 2 && isPermissionUpdateBooking">
                <feather-icon icon="CheckCircleIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="confirmCompleteRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.cancel')" position="top"
                        v-if="params.data.status != 3 && params.data.status != 4 && isPermissionUpdateBooking">
                <feather-icon icon="XIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmCancelRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top"
                        v-if="isPermissionDeleteBooking">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo popup_cancel" title="Xác nhận lý do hủy" :active.sync="popupCancel">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea v-model="cancelReason"/>
                </div>
                <div class="vx-col w-full">
                    <div class="flex float-right">
                        <vs-button class="mr-2" color="danger" iconPack="feather" icon="icon-check"
                                   @click="cancelRecord">{{
                                $t('button.confirm')
                            }}
                        </vs-button>
                        <vs-button class="" color="danger" type="border" iconPack="feather" icon="icon-x"
                                   @click="popupCancel = false">{{
                                $t('button.cancel')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo popup_confirm" title="Xác nhận lịch" :active.sync="popupConfirm">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label required">Chi nhánh</label>
                    <vs-input class="w-full" v-model="bookingInfo.organizationBranchName" disabled/>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">Khách hàng</label>
                    <vs-input class="w-full" v-model="bookingInfo.customerName" disabled/>
                </div>
                <div class="vx-col w-full mt-6">
                    <vs-radio v-model="packageType" vs-value="1" class="mr-4" disabled>Dịch
                        vụ
                    </vs-radio>
                    <vs-radio v-model="packageType" vs-value="2" disabled>Gói
                        dịch vụ
                    </vs-radio>
                </div>
                <div class="vx-col w-full mt-4" v-if="packageType == 1">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <label class="vs-input--label required">Nhóm dịch vụ</label>
                            <vs-input class="w-full" v-model="bookingInfo.beautySevice" disabled/>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">Chỉ tiêu</label>
                            <vs-input class="w-full" v-model="bookingInfo.beautySevicePack" disabled/>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label">Bác sĩ</label>
                            <v-select class="w-full" v-model="selectedDoctor" :options="doctorOptions" name="doctor">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full mt-4" v-if="packageType == 2">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <label class="vs-input--label required">Gói dịch vụ</label>
                            <vs-input class="w-full" v-model="bookingInfo.beautyCombo" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-4">
                    <label class="vs-input--label">Ngày</label>
                    <div class="w-full">
                        <datepicker :highlighted="highlighted" class="w-full" id="searchDate" :language="vi"
                                    :format="'dd/MM/yyyy'" v-model="selectDate" data-vv-validate-on="input"
                                    ref="datepickBooking"
                                    v-validate="'required'" name="time" disabled>
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-4">
                    <label class="vs-input--label">Giờ</label>
                    <div class="w-full">
                        <flat-pickr :config="configTimePicker" v-model="selectTime"
                                    class="w-full vs-inputx vs-input--input normal" name="time"/>
                    </div>
                </div>
                <div class="vx-col w-full">
                    <div class="flex float-right">
                        <vs-button class="mr-2" color="primary" iconPack="feather" icon="icon-check"
                                   @click="confirmCrm">{{
                                $t('button.confirm')
                            }}
                        </vs-button>
                        <vs-button class="" color="danger" type="border" iconPack="feather" icon="icon-x"
                                   @click="popupConfirm = false">{{
                                $t('button.cancel')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale';
import vSelect from 'vue-select';
import {isAPI} from "../../../../../store/permission";
import {constAPI} from "../../../../../store/constant";

export default {
    name: 'CellRendererActions',
    components: {
        flatPickr,
        Datepicker,
        vSelect,
    },
    data() {
        return {
            popupCancel: false,
            cancelReason: null,
            popupConfirm: false,
            bookingInfo: {
                organizationBranchName: null,
                customerName: null,
                beautyCombo: null,
                beautySevice: null,
                beautySevicePack: null,
                performerId: null,
            },
            packageType: null,
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            en: en,
            vi: vi,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            selectDate: new Date(),
            selectTime: new Date(),
            selectedBranchValue: null,
            selectedDepartmentValue: null,
            doctorOptions: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
        }
    },
    computed: {
        selectedDoctor: {
            get() {
                let obj = this.doctorOptions.find(x => x.value == this.bookingInfo.performerId);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.bookingInfo.performerId = obj ? obj.value : null;
            }
        },

        isPermissionCall() {
            // let permission = JSON.parse(localStorage.getItem('permissions'))
            // for (let per in permission) {
            //     if (per.functionName == constAPI.beauty_call) return true;
            //     return false
            // }
            return isAPI(this, constAPI.beauty_call);
        }
    },
    methods: {
        editRecord() {
            this.$router.push(`/user/booking-schedule-info?beautyBookingId=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: 'Bạn có chắc là muốn xóa lịch hẹn này không?',
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.get('/beauty-booking/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_BEAUTY_BOOKING', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        confirmCancelRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận hủy`,
                text: 'Bạn có chắc chắn muốn hủy lịch hẹn này không?',
                accept: this.openPopupcancel,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        openPopupcancel() {
            this.popupCancel = true;
            this.cancelReason = null;
        },

        cancelRecord() {
            if (!this.cancelReason) {
                return this.$vs.notify({
                    text: 'Lý do hủy là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            let payload = {
                id: this.params.data.id,
                cancelReason: this.cancelReason,
            };
            this.$vs.loading();
            this.$crm.post('/beauty-booking/cancel-booking', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Hủy lịch hẹn thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.popupCancel = false;
                this.$store.commit('DELETE_BEAUTY_BOOKING', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        async confirmRecord() {
            this.popupConfirm = true;
            this.selectedBranchValue = this.params.data.organizationBranchId;
            this.bookingInfo.organizationBranchName = this.params.data.organizationBranchName;
            this.bookingInfo.customerName = this.params.data.customerName;
            this.packageType = this.params.data.packageType;
            let infoService = this.params.data.beautyBookingDetails[0];
            this.selectDate = infoService.bookingDate;
            this.selectTime = infoService.startTime;

            if (infoService.beautyServicePackage || this.packageType == 1) {
                this.bookingInfo.beautySevicePack = infoService.beautyServicePackage.code + ' - ' + infoService.beautyServicePackage.name;
                this.bookingInfo.performerId = infoService.performerId;
                await this.findBeautyService(infoService.beautyServicePackage.id);
                await this.getDoctorData();
            }

            if (infoService.beautyPackageCombo || this.packageType == 2) {
                this.bookingInfo.beautyCombo = infoService.beautyPackageCombo.code + ' - ' + infoService.beautyPackageCombo.name;
            }

        },

        findBeautyService(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/beauty-service-package-department/find-by-condition', {beautyServicePackageId: id}).then(res => {
                    let result = res.data.content[0];
                    this.selectedDepartmentValue = result.departmentId;
                    this.bookingInfo.beautySevice = result.beautyService.code + ' - ' + result.beautyService.name;
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctorData() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                if (this.selectedBranchValue) {
                    url += '?organizationBranchId=' + this.selectedBranchValue
                }
                if (this.selectedDepartmentValue) {
                    url += '&departmentId=' + this.selectedDepartmentValue
                }

                this.doctorOptions = [];

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        confirmCrm() {
            let payload = {
                isDoctorCreate: true,
                id: this.params.data.id,
                beautyBookingDetails: [
                    {
                        bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
                        performerId: this.selectedDoctorCreateValue,
                        startTime: this.selectTime,
                        id: this.params.data.beautyBookingDetails[0].id,
                    }
                ]
            };
            this.$vs.loading();
            this.$crm.post('/beauty-booking/confirm-booking', payload).then(() => {
                this.$vs.loading.close();
                this.popupConfirm = false;
                this.$vs.notify({
                    color: 'success',
                    text: 'Đã xác nhận lịch hẹn!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_BEAUTY_BOOKING', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        confirmCompleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Xác nhận hoàn thành',
                text: 'Bạn có chắc chắn muốn xác nhận hoàn thành lịch hẹn này không?',
                accept: this.completeRecord,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },

        completeRecord() {
            this.$vs.loading();
            this.$crm.post('/beauty-booking/complete-booking', {id: this.params.data.id}).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Đã xác nhận hoàn thành lịch hẹn!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('DELETE_BEAUTY_BOOKING', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        isPermissionUpdateBooking() {
            return isAPI(this, constAPI.beauty_booking_update);
        },

        isPermissionDeleteBooking() {
            return isAPI(this, constAPI.beauty_booking_delete);
        },

        callToCustomer() {
            this.$eventBus.$emit("beauty-call", this.params.data.loyaltyCustomer);
        }
    },
}
</script>

<style lang="scss">
.popup_cancel .vs-popup--header {
    background: rgba(var(--vs-danger));
}

.popup_confirm .vs-popup--header {
    background: rgba(var(--vs-primary));
}

</style>
